// config.js

import { color } from "d3";
let backendbasurl=""
let backendbasurltb=""
let bankendregisterserviceurl=""
let bankendadmineurl=""
const hostname = window && window.location && window.location.hostname;
if (
    hostname.includes("staging") || hostname.includes("localhost")
    )
    {
        
        backendbasurl="https://backoffice-backend-staging.tradeboss.co/"
        backendbasurltb="http://localhost:5000/"
        bankendregisterserviceurl="https://registration-service-staging.tradeboss.co/"
        bankendadmineurl="https://bullforce-trader-admin-backend-staging.bullforce.co/"
    }else{

        backendbasurl="https://backoffice-backend.tradeboss.co/"
        backendbasurltb="http://localhost:5000/"
        bankendregisterserviceurl ="https://registration-service.tradeboss.co/"
        bankendadmineurl="https://bullforce-trader-admin-backend-staging.bullforce.co/"
    }

 
    
class AppConfig {
    static baseUrl = backendbasurl//process.env.REACT_APP_API_URL;
    static baseUrlTb = bankendregisterserviceurl
    static baseRegisterServiceUrl = bankendregisterserviceurl;
    static bankendAdmineUrl = bankendadmineurl;
    static authControlUrl = process.env.REACT_APP_AUTH_TOKEN_URL;
    static baseTokenUrl = process.env.REACT_APP_TOKEN_URL;
    static appRedirectUrl = process.env.REACT_APP_REDIRECT_URL;
    static drawerItems = [
        'Dashboard',
        'Ledger',
        'Depository',
        'Tradebook',
        'PandL',
        'Report',
        {
            label: "Manage Accounts",
            children: ["MyProfile", "BankAccount", "AccountClosure", "ActivateFnO", 'AddNominee',"ActivatePoa"]
        }
    ];
    static drawerItemsUrls = {
        Dashboard: "/dashboard",
        Ledger: "/ledger",
        Depository: "/depository",
        AddFunds: "/dashboard/addfunds",
        Tradebook: "/tradebook",
        PandL: "/pandl",
        MyProfile: "/manage-accounts/myprofile",
        BankAccount: "/manage-accounts/bankaccount",
        AddNominee: "/manage-accounts/addnominee",
        ActivateFnO: '/manage-accounts/activatefno',
        AccountClosure: '/manage-accounts/account-closure',
        ActivatePoa: '/manage-accounts/poa',
        Report: '/report'
        // Add more URLs for other drawer items as needed
    };
    static api = {
        Auth: {
            validateToken: `${this.baseUrl}auth/validate`
        },
        AuthControl: {
            loginToApiServer: `${this.baseUrl}auth/login`,
        },
        Ledger: {
            details: `${this.baseUrl}report/ledger`,
            summary: `${this.baseUrl}report/ledgersummary`,
            download: `${this.baseUrl}report/ledgerdownload`,
            downloadPDF : `${this.baseUrl}report/ledgerdownloadPDF`
        },
        Client: {
            info: `${this.baseUrl}report/clientinfo`,
            banks: `${this.baseUrl}report/clientbanks`,
            receipt: `${this.baseUrl}report/receipt`,
            holdings: `${this.baseUrl}report/holdings`,
            assets: `${this.baseUrl}report/assets`,
            getFnYear: `${this.baseUrl}report/yearinfo`,
            clientDpDetails: `${this.baseUrl}report/client-dp-details`
        },
        Payment: {
            payOrder: `${this.baseUrl}payment/payorder`,
            payStatus: `${this.baseUrl}payment/paystatus`,
            callback: `${this.baseUrl}payment/callback`,
            info: `${this.baseUrl}payment/info`,
            list: `${this.baseUrl}payment/list`,
            pg_payOrder: `${this.baseUrl}pg/payorder`,
        },
        Depository:{
            dpholding: `${this.baseUrl}depository/dpholding`,
            transactions: `${this.baseUrl}depository/transactions`,
        },
        Tradebook:{
            book: `${this.baseUrl}tradebook/book`,
        },
        Withdraw:{
            balance: `${this.baseUrl}withdraw/balance`,
            list: `${this.baseUrl}withdraw/list`,
            submit: `${this.baseUrl}withdraw/submit`,
            cancel: `${this.baseUrl}withdraw/cancel`,
        },
        PandL:{
            view: `${this.baseUrl}pandl/view`,
            derivative: `${this.baseUrl}pandl/derivative`,
        },
        margin:{
            balance:`${this.baseUrl}symphony/balance`,
        },
        Request : {
            addBank : `${this.baseUrl}addbank/verification`,
            editBank : `${this.baseUrl}addbank/edit`,
            eSign: `${this.baseRegisterServiceUrl}esign/authorize`,
            pdfPreview: `${this.baseUrl}nomination/nomination-previewPDF`,
            nomineeQuery: `${this.baseUrl}nomination/nomination-query`,
            bankVerStats: `${this.baseUrl}bankLogs/failed-record`,
            bankFileUpld:`${this.baseUrl}bankLogs/upload-doc`,
            RPD: `${this.baseUrl}addbank/rpd-create`,
            VerifyAcc: `${this.baseUrl}addbank/rpd-verify`,
        },
        Profile: {
            sendOtp: `${this.baseUrl}userupdate/send-otp`,
            verifyOtp: `${this.baseUrl}userupdate/verify-otp`,
            sendContactOtp: `${this.baseUrl}userupdate/send-new-otp`,
            verifyNewOtp: `${this.baseUrl}userupdate/verify-new-otp`,
            esign: `${this.baseRegisterServiceUrl}esign/authorize`,
            updateStats: `${this.baseUrl}userupdate/update-status`,
        },
        fno: {
            ocrCheck:`${this.baseRegisterServiceUrl}api/document/validate`,
            createRequest:`${this.baseRegisterServiceUrl}fno/create-request`,
            confirmDocs: `${this.baseRegisterServiceUrl}api/account-aggregator/upload`,
            requestStatus:`${this.baseRegisterServiceUrl}fno/request-status`,
            requestList:`${this.baseRegisterServiceUrl}fno/request-list`         
        },    
        UpdateFnO:{
            updateFnO: `${this.baseRegisterServiceUrl}api/account-aggregator/net-worth`
        },    
        OneMoney:{
            oneMoney:`${this.baseRegisterServiceUrl}setu/account_aggregator/create_consent`
        },
        AadharInfo:{
            aadharInfo:`${this.bankendAdmineUrl}api/fno/request_info`
        },
        RejectRequest:{
            rejectRequest:`${this.baseRegisterServiceUrl}api/fno/request_rejected`
        },

        A_closure_preview:{
            ac_preview: `${this.baseUrl}accountclosure/accountclosure-previewPDF`
        },
         A_closure_status:{
             ac_status: `${this.baseUrl}accountclosure/accountclosure-eSign-status`
         },
         A_init_closure:{
             ac_init: `${this.baseUrl}accountclosure/accountclosure-initiateClosure`
         },
         A_esign:{
             e_sign: `${this.baseRegisterServiceUrl}esign/authorize`
         },
        poa: {
            preview: `${this.baseRegisterServiceUrl}esign/ddpipreview`,
            authorize: `${this.baseRegisterServiceUrl}esign/authorize`,
            eSignStatus: `${this.baseUrl}ddpi/status`
        },
        Contract:{
            downloadPDF:`${this.baseUrl}report/contract`
        }
    }

    static withdrawStatus = {
        "Pending": "Pending", 
        "Rejected": "Cancelled",
        "Authorized": "Processed"
    };
    static downloadTypes = {
        CSV: "csv",
        PDF: "pdf",
        EXCEL: "excel",
        JSON: "json",
    };
    static paymentGateWay = {
        // Payment theme has changed - 14/10/23 - Dev Srini
        theme: {
            color: "#1A3B55",
        },
        currency: "INR",
        name: process.env.REACT_APP_RAZOR_NAME,
        // key: process.env.REACT_APP_RAZOR_KEY,
        // cryptoKey: process.env.REACT_APP_CRYPTO_KEY,   
        methodsObj: {
            netbanking: { "netbanking": 1},
            card: { "card": 1},
            upi: { "upi": 0},
            wallet: { "wallet": 0},
        }
    };
    static setBaseUrl(newBaseUrl) {
        AppConfig.baseUrl = newBaseUrl;
    };

    static getFormattedDate = function (nameText, type) {
        const currentDate = new Date();
        const day = currentDate.getDate().toString().padStart(2, '0');
        const month = (currentDate.getMonth() + 1).toString().padStart(2, '0'); // January is 0
        const year = currentDate.getFullYear().toString();
      
        return `${nameText}${day}${month}${year}.${type}`;
    }

    static removeQueryParams =  function(){
        const baseUrl = window.location.origin + window.location.pathname;
        window.history.replaceState({}, document.title, baseUrl);
    }
      
  }
  
  export default AppConfig;
  